import { AppointmentListingModel, IModel, ModelRecord } from "@common/models";
import { defaultTo } from "lodash";

export interface IAppointmentStatusRequest extends IModel {
    reservationId: number
    visitId: number | undefined
}

export class AppointmentStatusRequest implements ModelRecord<IAppointmentStatusRequest> {
    reservationId: number;
    visitId: number | undefined
    rowVersion: string;

    constructor(init?: Partial<IAppointmentStatusRequest>) {
        this.reservationId = defaultTo(init?.reservationId, 0);
        this.visitId = defaultTo(init?.visitId, 0);
        this.rowVersion = defaultTo(init?.rowVersion, '');
    }

    static FromListingModel(model: AppointmentListingModel) {
        return new AppointmentStatusRequest({
            reservationId: model.reservationId,
            visitId: model.visitId,
            rowVersion: model.rowVersion
        });
    }
}
